"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const services_1 = require("../../../common/services");
const UserProfileWrapper = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  background: #fff;
  font-size: 1rem;
  padding: 16px;
`;
const UserProfile = (props) => {
    const [disableButton, setDisableButton] = (0, react_1.useState)(false);
    const redirectToLogin = !props.userData.loginProviders[0].loggedIn;
    if (redirectToLogin) {
        window.location.replace(`${props.userData.loginProviders[0].loginUrl}&redirect_back_to=${window.location.origin}${props.baseUrl}`);
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const logout = () => {
        setDisableButton(true);
        services_1.apiService
            .logOut(props.userData.token, props.userData.loginProviders[0].slug)
            .then((userData) => {
            setDisableButton(false);
            props.history.push({
                pathname: `${props.baseUrl}`,
            });
            props.updateStore("userData", userData);
        });
    };
    const { firstName, lastName } = props.userData.account;
    return (react_1.default.createElement(UserProfileWrapper, null,
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6 }, i18n_js_1.default.t("account_first_name")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6 }, firstName),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6 }, i18n_js_1.default.t("account_last_name")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6 }, lastName),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6 }, i18n_js_1.default.t("account_logged_on")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6 }, props.userData.loginProviders[0].name),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Button, { color: "error", size: "large", onClick: logout, disabled: disableButton, variant: "contained", fullWidth: true, id: "aqa_user_logout" }, i18n_js_1.default.t("logout"))))));
};
const mapStoreToProps = (store) => ({
    userData: store.getValue("userData"),
    baseUrl: store.getValue("baseUrl"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(UserProfile));
